import { styled } from '@mui/material'

export const TopBarGlobalInfo = styled('div')(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '50px',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.info[100],
  zIndex: '1000',
  fontWeight: 'bold',
  overflow: 'visible',
  [theme.breakpoints.down(450)]: {
    height: 'auto',
    minHeight: '50px',
    paddingTop: '8px',
    paddingBottom: '8px'
  }
}))

export const Link = styled('a')(({ theme }) => ({
  margin: 0,
  padding: 0,
  [theme.breakpoints.down(800)]: {
    fontSize: '13px'
  },
  fontWeight: 400,
  cursor: 'pointer'
}))
